import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { TextInput, Button } from "flowbite-react";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechaFormatosGeneralesInterface } from "../../../../../interfaces/FechaFormatosGeneralesInterface";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import FooterAutorizacionVD from "../../../../../img/Footer_AutorizacionVD.png";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ProtestaFotocopiasEditarScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "PROTESTA PARA FOTOCOPIAS";
  const [formData, setFormData] = useState({
    day: "",
    month: "",
    year: "",
  });

  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const { control, handleSubmit, setValue, reset } = useForm();

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFechaFG = useGetData<FechaFormatosGeneralesInterface>({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const mutateFechaFG = useMutationData({
    url: `/fecha_formatosgenerales/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_formatosgenerales"],
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (queryFechaFG.data) {
      const fechafg = queryFechaFG.data;
      reset({
        fecha_protesta_fotocopias: fechafg.fecha_protesta_fotocopias || "",
      });
    }
  }, [queryFechaFG.data, reset]);

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`max-w-4xl mx-auto shadow-lg rounded-lg overflow-hidden mt-4 mb-4 relative div-ignore ${isDarkMode ? "bg-gray-800 text-white" : "bg-white"}`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);
            const formData = {
              ...data,
            };
            mutateFechaFG.mutate(
              {
                data: {
                  fecha_protesta_fotocopias: data.fecha_protesta_fotocopias,
                },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  navigate(`/formatosG/${evaluadosList_id}`);
                  window.scrollTo(0, 0);
                },
                onError: (error) => {
                  console.error(
                    "Error al guardar Fecha de Formatos Generales:",
                    error
                  );
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {/* Header */}
          <Header titulo={tituloFormulario} />
          {/* Contenido del formulario */}
          <div className="p-6 flex flex-col gap-6">
            {/* Texto principal */}
            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Bajo protesta de decir verdad, hago constar que la presente
              fotocopia fue tomada del documento original, mismo que cuenta con
              validez oficial y fue expedido por una institución con
              reconocimiento gubernamental.
            </p>

            <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
              Hago entrega a la empresa{" "}
              <strong>SKA TRACKING AND SECURITY S.A. de C.V.</strong> en la fecha:
              <Controller
                name="fecha_protesta_fotocopias"
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <input
                    id="fecha_protesta_fotocopias"
                    type="date"
                    value={
                      field.value ||
                      queryFechaFG.data?.fecha_protesta_fotocopias ||
                      ""
                    }
                    onChange={(e) => field.onChange(e.target.value)}
                    className={`border rounded-md p-2 w-[150px] ml-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-white border-gray-600" : "bg-white text-gray-700 border-gray-300"}`}
                  />
                )}
              />
            </p>

            {/* Datos del Evaluado */}
            <div className={`space-y-1 text-left ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
              <h2 className="text-lg font-bold">{`NOMBRE: ${
                queryEvaluado.data?.nombre || ""
              } ${queryEvaluado.data?.apellido_paterno || ""} ${
                queryEvaluado.data?.apellido_materno || ""
              }`}</h2>
              <h2 className="text-lg font-bold">{`EMPRESA: ${queryEvaluado.data?.empresa_id.nombre}`}</h2>
              <h2 className="text-lg font-bold">{`PUESTO: ${
                queryEvaluado.data?.puesto || ""
              }`}</h2>
            </div>
          </div>

          {/* Firma */}
          <div className="pt-16 text-center">
            <div className={`w-64 mx-auto border-t pt-2 ${isDarkMode ? "border-gray-400" : "border-black"}`}>
              <p className={`text-sm font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>FIRMA</p>
            </div>
          </div>

          {/* Botones */}
          <div className="mt-4 mb-4 px-4">
            <div className="flex justify-between">
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(-1);
                }}
                className={`${isDarkMode ? "bg-red-600 hover:bg-red-700" : "bg-red-500 hover:bg-red-600 text-white"}`}
              >
                Regresar
              </Button>
              <button
                type="submit"
                className={`rounded px-4 py-2 z-10 transition-colors ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 hover:bg-green-600 text-white"}`}
              >
                {" "}
                Guardar{" "}
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className={`h-12 mt-8 flex items-center justify-center ${isDarkMode ? "bg-blue-800" : "bg-customBlue"}`}>
            <p className="text-sm text-white px-4">
              <span className="font-bold">DOCUMENTO CONFIDENCIAL</span>, prohibido
              su reproducción, copia o sacar este documento de las Instalaciones
              de Skyangel
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};